import { FormControlLabel, Checkbox, Stack } from "@mui/material";
import { hasItems } from "common/arrays";
import { useSelector } from "react-redux";
import * as userSelectors from "store/selectors/user/userSelectors";

const SubjectivitiesElement = ({ data, onChange }) => {
  const isFormsAdmin = useSelector(userSelectors.isFormsAdminUser);
  const subjectivities = data?.subjectivities ?? [];
  const readOnly = typeof onChange !== "function";

  if (!hasItems(subjectivities)) {
    return <></>;
  }

  const handleChange = (key, checked) => {
    if (readOnly) return;
    const updated = subjectivities.map((x) =>
      x.key === key ? { ...x, fulfilled: checked } : x
    );
    onChange(updated);
  };

  return (
    <Stack>
      {subjectivities.map((x) => (
        <FormControlLabel
          key={x.key}
          label={x.text}
          control={
            <Checkbox
              checked={x.fulfilled}
              onChange={(e) => handleChange(x.key, e.target.checked)}
              disabled={readOnly || !isFormsAdmin}
            />
          }
        />
      ))}
    </Stack>
  );
};

export default SubjectivitiesElement;
